import React from "react";
import { LoginPage } from "./LoginPage";
import { Register } from "./Register";

export const MyAccount = () => {
  return (
    <div className="" style={{ width: "99vw", height: "100vh" }}>
      <div className="row m-auto h-100">
        <div className="col-10 m-auto">
          <ul
            className="nav nav-pills justify-content-center pb-0"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-login-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-login"
                type="button"
                role="tab"
                aria-controls="pills-login"
                aria-selected="true"
              >
                Iniciar Sesión
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-register-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-register"
                type="button"
                role="tab"
                aria-controls="pills-register"
                aria-selected="false"
              >
                Crear cuenta
              </button>
            </li>
          </ul>
          <div className="tab-content mt-0 pt-0" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-login"
              role="tabpanel"
              aria-labelledby="pills-login-tab"
              tabIndex="0"
            >
              <LoginPage />
            </div>
            <div
              className="tab-pane fade"
              id="pills-register"
              role="tabpanel"
              aria-labelledby="pills-register-tab"
              tabIndex="0"
            >
              <Register />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
